export default __webpack_public_path__ + "static/media/lizzie.c1ee2c29.png";